export const REACT_APP_DYNA_CROP_API_KEY = "QSlwK35RiUQisYQNznbN";
export const DYNA_CROP_BASE_URL = "https://api.dynacrop.space/api/v3";
